import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import classNames from "classnames";

class TabContent extends React.Component {

    static propTypes = {
        tabName: PropTypes.any,
        tabLabel: PropTypes.any,
    }

    render() {
        return (
            <Fragment>
                <div className={classNames("tab-content", this.props.className, {"hidden": !this.props.active})}>
                    <div className="tab-pane fade in show active">
                        {this.props.children}
                    </div>
                </div>
                {!!this.props.footer && <div className="tab-footer">
                    {this.props.footer}
                    <div className="clearfix"/>
                </div>}
            </Fragment>
        );
    }
}
export default TabContent;